import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {useI18n} from '../../../../data/hooks/i18nHooks';
import styles from './MeetingConfirmButton.module.scss';
import meetingState from '../../../../data/constants/meetingState';
import { isMeetingConfirmed } from 'common-data-handling';

function MeetingConfirmButton(props) {
    const {className = '', meeting} = props,
        i18n = useI18n(),
        dispatch = useDispatch();

    const handleConfirm = useCallback(() => {
        dispatch(app.actions.ui.busy());
        app.api.meetings.accept(meeting.id).finally(() => {
            dispatch(app.actions.ui.free());
        });
    }, [meeting]);

    if (meeting._state != meetingState.PENDING) return null;
    if (!meeting._myInvite) return null;
    if (isMeetingConfirmed(meeting)) return null;

    return (
        <button type="button" className={[className, styles.MeetingConfirmButton].join(' ')} onClick={handleConfirm}>
            {i18n['label.confirm']}
        </button>
    );
}

export default MeetingConfirmButton;
